import { Injectable } from '@angular/core';
import { ContextMenuComponent } from 'src/app/components/ux/context-menu/context-menu.component';

@Injectable({
  providedIn: 'root'
})
export class ContextMenuService {
  private openMenu: ContextMenuComponent[] = [];

  constructor() { }

  register(menu: ContextMenuComponent): void {
    this.openMenu.push(menu);
  }

  show(menu: ContextMenuComponent, x: number, y: number): void {
    this.register(menu);
    menu.show(x, y);
  }

  close() {
    this.openMenu.forEach(m => m.close());
    this.openMenu = [];
  }
}
